import { LicenseUser } from '../../models/license-user';
import { SmsInviteStatus } from '@tmx/data-access';

export const mapSmsStatusesToAssets = (
  smsStatuses: SmsInviteStatus[],
  assets: LicenseUser[]
) => {
  for (const asset of assets) {
    const smsStatus = smsStatuses.find(
      (responseRow) => asset.externalId === responseRow.entityId
    );
    if (smsStatus) {
      asset.smsStatus = smsStatus;
    }
  }
  return assets;
};
